// extracted by mini-css-extract-plugin
export default {"contenedor":"Login_contenedor__LXX39","contenedorForm":"Login_contenedorForm__w-nPw","inputLogin":"Login_inputLogin__gpwr1","loadingBotonLogin":"Login_loadingBotonLogin__eHr6n"};